import clsx from "clsx"
export default function TextArea(props){
    return (
        <textarea 
        {...props}
        className={clsx(
            "w-full bg-zoeil-grey px-[1.25rem] py-[1rem] text-[1.375rem] small-computer:text-large placeholder-black placeholder-opacity-60 outline-none resize-y"
        )
        }
        rows={5}
        onChange={(e)=>{
            props.changeHandler(e.target.value);
        }}>
            {props.value}
        </textarea>
    )
}